import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { FaceIdIcon } from "../../atoms/icons/easy_login/FaceIdIcon";
import { PassKeyIcon } from "../../atoms/icons/easy_login/PassKeyIcon";
import { QrCodeIcon } from "../../atoms/icons/easy_login/QrCodeIcon";
import { CardTemplate } from "../../templates/CardTemplate";
import { useLoginPasskey } from "./hook";
import { useEffect } from "react";

export const LoginPasskeyPage: React.FC = () => {
  const { handleLoginPasskey, handleCancel } = useLoginPasskey();

  useEffect(() => {
    handleLoginPasskey();
  }, []);

  return (
    <CardTemplate title="パスキーでログイン">
      <StyledTextContainer>
        パスキーでログインしてください。
      </StyledTextContainer>

      <StyledIconContainer>
        <FaceIdIcon />
        <PassKeyIcon />
        <QrCodeIcon />
      </StyledIconContainer>

      <StyledFooter>
        <Button
          text="ログイン"
          variant="filled"
          onClick={handleLoginPasskey}
          fullWidth
        />
        <Button
          variant="link"
          text="別の方法でログイン"
          type="button"
          onClick={handleCancel}
        />
      </StyledFooter>
    </CardTemplate>
  );
};

const StyledIconContainer = styled.div`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex: 1 0 0;
`;

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
